module.exports = "/images/rts.svg?5c3e015228c51a52b39a4c62db06f44f";